import styled from 'styled-components';
import COLORS from '../../../constants/COLORS';

const Error = styled.div`
  color: ${COLORS.RED};
  font-size: 14px;
`;

export default Error;
